<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-sixe:15px; font-weight: bold">update bond tracking</small>
      </legend>
      <div>
        <form @submit.prevent="updateBondtracking()">
          <div class="row">
            <input type="hidden" class="id" :value="Bondtracking.id" />
            <input type="hidden" class="cargo_id" :value="Bondtracking.cargo_id" />
            <input type="hidden" class="requisition_id" :value="Bondtracking.requisition_id" />
            <input type="hidden" class="truck_id" :value="Bondtracking.truck_id" />
            <input type="hidden" class="bond_id" :value="Bondtracking.bond_id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Ro</label>
                <select name="Ro" class="form-control Ro input-rounded f-s-14" :value="Bondtracking.Ro">
                  <option value>Select RO</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>Coe</label>
                <select name="coe" class="form-control coe input-rounded f-s-14" :value="Bondtracking.coe">
                  <option value>Select coe</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Loading report</label>
                <select
                  name="l_reporting"
                  class="form-control l_reporting input-rounded f-s-14"
                  :value="Bondtracking.l_reporting"
                >
                  <option value>Select Loadin report</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>malaba collection</label>
                <input
                  type="date"
                  class="form-control ml_collection input-rounded f-s-14"
                  :value="Bondtracking.ml_collection"
                  placeholder="malaba collection"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingBondtracking btn-rounded">
            <i class="fa fa-plus"></i> update bond
          </button>
          <button type="button" class="btn btn-info btn-flat updatingBondtrackingLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Bondtracking.length === 0) {
      router.push("/managebondtrackings");
    }
  },
  computed: {
    ...mapGetters(["Bondtracking"])
  },
  methods: {
    ...mapActions(["updateBondtracking"])
  }
};
</script>
<style scoped>
.updatingBondtrackingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/bondtrackings/updatebondtracking.vue